export default __webpack_public_path__ + "static/media/Red-BG-End.dfe65b90.svg";